export enum AddSlideShowModalState {
  Upload = 'upload',
  GoogleDrive = 'google-drive',
}
